interface InstallationCurrency {
	id: number;
	code: string;
	number: number;
	minorUnits: number;
	display: CurrencyDisplay;
}

enum CurrencyDisplay {
	Symbol,
	NarrowSymbol,
	Code,
	Name
}

export {InstallationCurrency, CurrencyDisplay};
